import React, { useContext, useState, useEffect } from "react";
import EventContext from "../event/eventContext";

const LessonItem = ({ hw }) => {
  const date = new Date(hw.lessonDate); // 2009-11-10
  const day = date.getDate();
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "short" });
  const newDate = day + ". " + " " + month + " " + year;

  const [yt, setYt] = useState(null);

  useEffect(() => {
    if (hw.ytLink) {
      const str = hw.ytLink;
      const ytString = str.replace(
        "https://www.youtube.com/watch?v=",
        "https://www.youtube.com/embed/"
      );
      setYt(ytString);
    }
  }, []);

  const eventContext = useContext(EventContext);
  const { circle } = eventContext;
  return (
    <div>
      <section
        className={
          hw.isBlue
            ? "work-container-blue"
            : hw.isGreen
            ? "work-container-green"
            : hw.isPurple
            ? "work-container-purple"
            : "work-container"
        }
      >
        <div className='work-general'>
          <div className='work-title'>
            <h1>{hw.lesson} UČNA URA</h1>
          </div>
          <div className='work-info'>
            <div className='work-info-item'>
              <h1>RAZRED</h1>
              <p>{hw.lessonClassName}</p>
            </div>
            <div className='work-info-item'>
              <h1>DATUM</h1>
              <p>{newDate}</p>
            </div>
            <div className='work-info-item'>
              <h1>NASLOV URE</h1>
              <p>{hw.lessonTitle}</p>
            </div>
          </div>
          <div className='work-instructions'>
            <div className='work-navodila'>
              <h1>Navodila</h1>
              <p>{hw.lessonInstructionsOne}</p>
              <p>{hw.lessonInstructionsTwo}</p>
            </div>
            <div className='work-hw'>
              <h1>Utrjevanje / naloge</h1>
              <p>{hw.lessonHomeworkOne}</p>
              <p>{hw.lessonHomeworkTwo}</p>
              <p>{hw.lessonHomeworkThree}</p>
            </div>
          </div>
          <div className='work-navodila'>
            <h1 className='povezave-title'>Povezave</h1>
            {!hw.lessonLinkOne &&
            !hw.lessonLinkTwo &&
            !hw.lessonLinkThree &&
            !hw.lessonLinkFour ? (
              <h3>Ni povezav za to učno uro</h3>
            ) : (
              false
            )}
            <h3>
              {hw.lessonLinkOne && "1."} {hw.lessonLinkOneInfo}
            </h3>
            <a href={hw.lessonLinkOne} target='_blank'>
              {hw.lessonLinkOne}
            </a>
            <h3>
              {hw.lessonLinkTwo && "2."} {hw.lessonLinkTwoInfo}
            </h3>
            <a href={hw.lessonLinkTwo} target='_blank'>
              {hw.lessonLinkTwo}
            </a>
            <h3>
              {hw.lessonLinkThree && "3."} {hw.lessonLinkThreeInfo}
            </h3>
            <a href={hw.lessonLinkThree} target='_blank'>
              {hw.lessonLinkThree}
            </a>
            <h3>
              {hw.lessonLinkFour && "4."} {hw.lessonLinkFourInfo}
            </h3>
            <a href={hw.lessonLinkFour} target='_blank'>
              {hw.lessonLinkFour}
            </a>
          </div>
        </div>
        {hw.ytLink || hw.ytLinkInfo ? (
          <div className='work-section'>
            <div className='work-section-title'>
              <h1>Video</h1>
            </div>
            <div className='work-section-instructions'>
              <h1>{hw.ytLinkInfo}</h1>
              <p>
                Če video ne dela, uporabi povezavo:{" "}
                <a
                  href={hw.ytLink}
                  target='_blank'
                  style={{ color: "blue", fontSize: "1.6rem" }}
                >
                  VIDEO
                </a>
              </p>
            </div>
            <div className='work-google'>
              <iframe
                width='560'
                height='315'
                src={yt}
                frameborder='0'
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                allowfullscreen
              ></iframe>
            </div>
          </div>
        ) : (
          false
        )}
        {hw.pdfSrc ? (
          <div className='work-section'>
            <div className='work-section-title'>
              <h1>PDF</h1>
            </div>
            <div className='work-section-instructions'>
              <h1>{hw.pdfInfo}</h1>
            </div>
            <div className='work-google'>
              <iframe src={hw.pdfSrc} width='100%' height='500px'></iframe>
            </div>
          </div>
        ) : (
          false
        )}
        {hw.lessonPartOneSrc ? (
          <div className='work-section'>
            <div className='work-section-title'>
              <h1>1. sklop</h1>
            </div>
            <div className='work-section-instructions'>
              <h1>{hw.lessonPartOneInstructions}</h1>
            </div>
            <div className='work-google'>
              <iframe
                src={hw.lessonPartOneSrc}
                frameborder='0'
                width='1920'
                height='560'
                allowfullscreen='true'
                mozallowfullscreen='true'
                webkitallowfullscreen='true'
              ></iframe>
            </div>
          </div>
        ) : (
          false
        )}
        {hw.lessonPartTwoSrc ? (
          <div className='work-section'>
            <div className='work-section-title'>
              <h1>2. sklop</h1>
            </div>
            <div className='work-section-instructions'>
              <h1>{hw.lessonPartTwoInstructions}</h1>
            </div>
            <div className='work-google'>
              <iframe
                src={hw.lessonPartTwoSrc}
                width='1080'
                height='1050'
                frameborder='0'
                marginheight='0'
                marginwidth='0'
              ></iframe>
            </div>
          </div>
        ) : (
          false
        )}
        {hw.lessonPartThreeSrc ? (
          <div className='work-section'>
            <div className='work-section-title'>
              <h1>2. sklop</h1>
            </div>
            <div className='work-section-instructions'>
              <h1>{hw.lessonPartThreeInstructions}</h1>
            </div>
            <div className='work-google'>
              <iframe
                src={hw.lessonPartThreeSrc}
                width='1600'
                height='1050'
                frameborder='0'
                marginheight='0'
                marginwidth='0'
              ></iframe>
            </div>
          </div>
        ) : (
          false
        )}
        {hw.lessonPartFourSrc ? (
          <div className='work-section'>
            <div className='work-section-title'>
              <h1>2. sklop</h1>
            </div>
            <div className='work-section-instructions'>
              <h1>{hw.lessonPartFourInstructions}</h1>
            </div>
            <div className='work-google'>
              <iframe src={hw.lessongPartFourSrc}></iframe>
            </div>
          </div>
        ) : (
          false
        )}
      </section>
      <button className='work-button'>NAZAJ NA VRH</button>
    </div>
  );
};

export default LessonItem;
